var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.196 4.5715C24.3102 1.744 20.3591 0 15.9999 0C14.6086 0 10.5378 1.744 7.6521 4.5715H27.196Z",
    fill: "#6DA544"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 13.7143H31.8367C31.6058 12.1002 31.1344 10.5639 30.4593 9.14282H15.3043L15.9999 13.7143Z",
    fill: "#6DA544"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.54065 22.8572H30.4593C31.1344 21.4361 31.6058 19.8998 31.8367 18.2857H0.163208C0.394145 19.8998 0.865458 21.4362 1.54065 22.8572V22.8572Z",
    fill: "#6DA544"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80383 27.4285C7.68965 30.256 11.6408 32 16 32C20.3591 32 24.3103 30.256 27.1961 27.4285H4.80383Z",
    fill: "#6DA544"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.93958 0 1.27246 5.96069 0.163208 13.7143H16V0Z",
    fill: "#D80027"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00007 12.2667L7.30444 10.8754V8.09279L9.04357 6.70148L10.7827 8.09279V10.1797L11.4783 9.4841V10.8754L10.087 12.2667H8.00007Z",
    fill: "#F0F0F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25846 8L4.44265 8.56688H5.03865L4.55646 8.91731L4.74071 9.48413L4.25846 9.13375L3.77621 9.48413L3.96046 8.91731L3.47827 8.56688H4.07427L4.25846 8Z",
    fill: "#F0F0F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64982 6.60864L5.834 7.17552H6.43007L5.94782 7.52595L6.132 8.09277L5.64982 7.74245L5.16763 8.09277L5.35188 7.52595L4.86963 7.17552H5.46557L5.64982 6.60864Z",
    fill: "#F0F0F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04117 5.21735L7.22536 5.78422H7.8213L7.33917 6.13466L7.5233 6.70147L7.04117 6.35116L6.55892 6.70147L6.74311 6.13466L6.26099 5.78422H6.85692L7.04117 5.21735Z",
    fill: "#F0F0F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8286 8L13.6444 8.56688H13.0485L13.5306 8.91731L13.3464 9.48413L13.8286 9.13375L14.3108 9.48413L14.1266 8.91731L14.6088 8.56688H14.0128L13.8286 8Z",
    fill: "#F0F0F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4372 6.60864L12.253 7.17552H11.6571L12.1392 7.52595L11.955 8.09277L12.4372 7.74245L12.9195 8.09277L12.7352 7.52595L13.2174 7.17552H12.6215L12.4372 6.60864Z",
    fill: "#F0F0F0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0461 5.21735L10.8618 5.78422H10.2659L10.748 6.13466L10.5638 6.70147L11.0461 6.35116L11.5282 6.70147L11.3441 6.13466L11.8262 5.78422H11.2302L11.0461 5.21735Z",
    fill: "#F0F0F0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04349 4.52173L8.85924 5.0886H8.26331L8.74543 5.43898L8.56124 6.00579L9.04349 5.65548L9.52568 6.00579L9.34149 5.43898L9.82362 5.0886H9.22768L9.04349 4.52173Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAb);
export default __webpack_public_path__ + "static/media/AB.2c54271a.svg";
export { ForwardRef as ReactComponent };